import { UiComponents } from "@simulanisindia/ui";
import Sidebar from "./Sidebar";
import Header from "./Header";

const { MainLayout } = UiComponents;

const ChildrenComponent = ({ children }) => children;

const Private = ({ children }) => {
  return (
    <>
      <MainLayout
        Header={<Header />}
        SideBar={<Sidebar />}
        Component={<ChildrenComponent> {children} </ChildrenComponent>}
      />
    </>
  );
};

export default Private;
